import Utils from "../utils/Utils";

const getAuth = ({ jwt, Authorization } = {}) => jwt || Authorization || "";

const addParam = (params, key, value) => {
  if (value !== undefined && value !== null && value !== "") {
    params.append(key, value);
  }
};

const getFeaturedId = ({
  featuredId,
  featuredID,
  featuredPlacementId,
  featuredPlacementID,
  id,
} = {}) =>
  featuredId || featuredID || featuredPlacementId || featuredPlacementID || id;

const featuredPlacementController = {
  addFeatured: ({ Authorization, jwt, request } = {}) => {
    return Utils.controller(
      "api/featured/v1/addFeatured",
      request,
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
      "*/*",
    );
  },

  deleteFeaturedById: ({
    Authorization,
    featuredId,
    featuredID,
    featuredPlacementId,
    featuredPlacementID,
    id,
    jwt,
  } = {}) => {
    const params = new URLSearchParams();

    addParam(
      params,
      "featuredId",
      getFeaturedId({
        featuredId,
        featuredID,
        featuredPlacementId,
        featuredPlacementID,
        id,
      }),
    );

    return Utils.controller(
      "api/featured/v1/deleteFeaturedById",
      "",
      "DELETE",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
      "*/*",
    );
  },

  getFeaturedById: ({
    Authorization,
    featuredId,
    featuredID,
    featuredPlacementId,
    featuredPlacementID,
    id,
    jwt,
  } = {}) => {
    const params = new URLSearchParams();

    addParam(
      params,
      "featuredId",
      getFeaturedId({
        featuredId,
        featuredID,
        featuredPlacementId,
        featuredPlacementID,
        id,
      }),
    );

    return Utils.controller(
      "api/featured/v1/getFeaturedById",
      "",
      "GET",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
      "*/*",
    );
  },

  getFeaturedCategories: ({ Authorization, jwt } = {}) => {
    return Utils.controller(
      "api/featured/v1/getFeaturedCategories",
      "",
      "GET",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
      "*/*",
    );
  },
};

export default featuredPlacementController;
